import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import TicketsTable from '../TicketsTable';

const TicketsTabs = ({
    tab,
    handleChangeTab,
    filteredResults,
    isLoading,
    handleState,
    states,
}) => {
    return (
        <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                    onChange={handleChangeTab}
                    aria-label="Tickets"
                >
                    {states.map((state) => (
                        <Tab key={'tab' + state} label={state} value={state} />
                    ))}
                </TabList>
            </Box>
            {states.map((state) => (
                <TabPanel key={'panel' + state} value={state}>
                    <TicketsTable
                        filteredResults={filteredResults}
                        isLoading={isLoading}
                        handleState={handleState}
                    />
                </TabPanel>
            ))}
        </TabContext>
    );
};

export default TicketsTabs;
